import {
    AUTHENTICATING_MARKETO_REQUEST, AUTHENTICATING_MARKETO_SUCCEDDED, AUTHENTICATING_MARKETO_FAILED,
    UPDATING_MARKETO_REQUEST, UPDATING_MARKETO_SUCCEDDED, UPDATING_MARKETO_FAILED,
  } from '../../actions/actionTypes.jsx';
  
  import { combineReducers } from 'redux';
  
  const initialState = {
    changes: {
        saving: false,
        error: null,
        configuration: {}
    },
    activation: {
      activating: false,
      error: null
    },
    deactivation: {
      deactivating: false,
      error: null
    }
  };
  
  function marketoReducer(state = initialState, action) {
    switch (action.type) {
      case AUTHENTICATING_MARKETO_REQUEST:
        return Object.assign({}, state, {
          ...state,
          activation: {
            activating: true,
            error: null
          }
        })
      case AUTHENTICATING_MARKETO_SUCCEDDED:
        return Object.assign({}, state, {
          ...state,
          activation: {
            activating: false,
            error: null
          }
        })
      case AUTHENTICATING_MARKETO_FAILED:
        return Object.assign({}, state, {
          ...state,
          activation: {
            activating: false,
            error: action.payload
          }
        })
  
      case UPDATING_MARKETO_REQUEST:
        return Object.assign({}, state, {
            ...state,
            changes: {
              saving: true,
              error: null
            }
        })
      case UPDATING_MARKETO_SUCCEDDED:
        const {configuration} = action.payload;

        return Object.assign({}, state, {
            ...state,
            changes: {
              ...state.changes,
              saving: false,
              configuration: configuration,
              error: null
            }
        })
      case UPDATING_MARKETO_FAILED:
        return Object.assign({}, state, {
            ...state,
            changes: {
              ...state.changes,
              saving: false,
              error: action.payload
            }
        })   
      default:
        return state
    }
  }
  
  export { marketoReducer };